import React, { useEffect, useState, useRef } from 'react';
import authService from '../Auth/AuthService';
import { CircularProgress, Typography } from '@mui/material';
import ProfileCard from './ProfileCard';

const ProfilePage = () => {
    const [loading, setLoading] = useState(true);
    const [login, setLogin] = useState(null);
    const [school, setSchool] = useState();
    const hasFetched = useRef(false);
    const DOC_URL = authService.DOC_URL

    useEffect(() => {
        const fetchLoginData = async () => {
            if (hasFetched.current) return;
            hasFetched.current = true;

            try {
                const url = authService.pathUrl("GET", "/schools/email");
                const schoolsData = await authService.getAuth(url);
                // const updatedForm = {
                //     ...schoolsData,
                //     logoUrl: DOC_URL + schoolsData.logoUrl
                // };
                setSchool(schoolsData);
                localStorage.setItem("name", schoolsData.schoolName);
                localStorage.setItem("logoUrl", DOC_URL + schoolsData.logoUrl);
                if (schoolsData.schoolName === 'undefined' || localStorage.getItem("name") === 'undefined') {
                    // console.log(loginInfo.mas_id, typeof loginInfo.mas_id);
                    setSchool(null)
                }
            } catch (error) {
                console.error("Error fetching schools:", error);
            }
            try {
                const url = authService.pathUrl("GET", "/auth");
                const data = await authService.getAuth(url);
                setLogin(data);
            } catch (error) {
                console.error("Error fetching login data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLoginData();
    }, []);

    if (loading)
        return <CircularProgress sx={{ mt: 5, mx: 'auto', display: 'block' }} />;

    if (!login)
        return (
            <Typography variant="h6" color="error" align="center" sx={{ mt: 5 }}>
                Failed to load login data.
            </Typography>
        );

    return <ProfileCard login={login} school={school} onSuccess={window.location.reload} />;
};

export default ProfilePage;
